import { prostateSegOptions } from "./constants";
import { sceneOrientations } from "../../constants";

export const initialState = {
    selectedSegmentation: prostateSegOptions.UPLOADED_SEG,
    viewerOrientation: sceneOrientations.AXIAL,
};
